import { useState } from "react";
import { NavLink } from "react-router-dom";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import SiteLogo from "../SiteLogo/SiteLogo";
import { useTranslation } from "../../i18n/LanguageProvider";
import { getDefaultWomanImageUrl, getPublicAssetUrl } from "../../utils/imageUrl";
import "./Header.sass";

function Header({ showHero = true }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const { t, localizedPath } = useTranslation();

    return (
        <header
            className="header"
            style={{
                backgroundImage: `url(${getPublicAssetUrl("/images/bg.png")})`,
            }}>
            <div className="header__container general-wrapper">
                <SiteLogo to={localizedPath("/")} variant="header" />

                <nav className={`header__nav ${menuOpen ? "header__nav--open" : ""}`}>
                    <NavLink end to={localizedPath("/")} className="header__link" onClick={() => setMenuOpen(false)}>
                        {t("nav.home")}
                    </NavLink>
                    <NavLink to={localizedPath("/femei")} className="header__link" onClick={() => setMenuOpen(false)}>
                        {t("nav.directory")}
                    </NavLink>
                    <NavLink to={localizedPath("/noutati")} className="header__link" onClick={() => setMenuOpen(false)}>
                        {t("nav.news")}
                    </NavLink>
                    <NavLink to={localizedPath("/despre-noi")} className="header__link" onClick={() => setMenuOpen(false)}>
                        {t("nav.about")}
                    </NavLink>
                    <NavLink to={localizedPath("/contact")} className="header__link" onClick={() => setMenuOpen(false)}>
                        {t("nav.contact")}
                    </NavLink>
                </nav>

                <div className="header__controls">
                    <LanguageSelector onSelect={() => setMenuOpen(false)} />
                    <button
                        className={`header__burger ${menuOpen ? "open" : ""}`}
                        onClick={() => setMenuOpen((prev) => !prev)}
                        aria-label="Toggle menu">
                        <span />
                        <span />
                        <span />
                    </button>
                </div>
            </div>
            {showHero && (
                <div className="header__hero general-wrapper">
                    <h1 className="title">{t("hero.title")}</h1>
                    <div
                        className="button"
                        onClick={() => {
                            document.getElementById("filters")?.scrollIntoView({ behavior: "smooth" });
                        }}>
                        {t("hero.cta")}
                    </div>
                    <div className="image" style={{ backgroundImage: `url(${getDefaultWomanImageUrl()})` }}></div>
                </div>
            )}
        </header>
    );
}

export default Header;
